import React from "react";
import i18next from "i18next";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { FormGroup, FormControl, FormLabel, Row, Col } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { companyService, authService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import * as companyActions from "actions/companyActions";
import "styles/components/CreateCompanyModal.scss";

class CreateCompanyModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			submitted: false,
			touched: {},
			errors: {},
			company: {
				name: "",
				vat_number: "",
				address: "",
				postal_code: "",
				city: "",
				province: "",
				country_iso: "ES",
				phone: "",
				web: "",
				email: "",
			},
		};
	}

	componentDidMount() {
		// Cargar la lista de países si no está cargada
		if (this.props.countries.length === 0) {
			this.props.getCountries();
		}
	}

	handleChange = (e) => {
		const { name, value } = e.target;
		this.setState((prevState) => ({
			company: {
				...prevState.company,
				[name]: value,
			},
			errors: {
				...prevState.errors,
				[name]: null, // Limpiar error al cambiar el campo
			},
		}));
	};

	handleBlur = (e) => {
		const { name, value } = e.target;
		this.setState((prev) => ({ touched: { ...prev.touched, [name]: true } }));

		if (name === "name") {
			const nameTrimmed = (value || "").trim().toLowerCase();
			const tokens = authService.getAllCompanyTokens() || [];
			const exists = tokens.some(
				(t) => (t.company_name || "").trim().toLowerCase() === nameTrimmed
			);
			if (exists) {
				this.setState((prev) => ({
					errors: {
						...prev.errors,
						name: i18next.t("createCompany.errorNameDuplicate"),
					},
				}));
			}
		}
	};

	checkValidField = (fieldName) => {
		const { submitted, touched = {}, errors = {} } = this.state;
		return !!errors[fieldName] && (submitted || touched[fieldName]);
	};

	validateForm = () => {
		const { company } = this.state;
		const errors = {};

		// Campo requerido: solo el nombre de la empresa
		if (!company.name || !company.name.trim()) {
			errors.name = i18next.t("createCompany.errorNameRequired");
		}

		// Duplicados por nombre (comparación case-insensitive y trim)
		const tokens = authService.getAllCompanyTokens() || [];
		const nameTrimmed = (company.name || "").trim().toLowerCase();
		if (nameTrimmed) {
			const exists = tokens.some(
				(t) => (t.company_name || "").trim().toLowerCase() === nameTrimmed
			);
			if (exists) {
				errors.name = i18next.t("createCompany.errorNameDuplicate");
			}
		}

		// VALIDACIONES COMENTADAS - Para recuperar en el futuro, descomentar estas líneas:
		// if (!company.vat_number || !company.vat_number.trim()) {
		// 	errors.vat_number = 'El NIF/CIF es obligatorio';
		// }

		// if (!company.address || !company.address.trim()) {
		// 	errors.address = 'La dirección es obligatoria';
		// }

		// if (!company.postal_code || !company.postal_code.trim()) {
		// 	errors.postal_code = 'El código postal es obligatorio';
		// }

		// if (!company.city || !company.city.trim()) {
		// 	errors.city = 'La ciudad es obligatoria';
		// }

		// if (!company.province || !company.province.trim()) {
		// 	errors.province = 'La provincia es obligatoria';
		// }

		// if (!company.country_iso || !company.country_iso.trim()) {
		// 	errors.country_iso = 'El país es obligatorio';
		// }

		// if (!company.email || !company.email.trim()) {
		// 	errors.email = 'El email es obligatorio';
		// } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(company.email.trim())) {
		// 	errors.email = 'El formato del email no es válido';
		// }

		// Validación opcional del teléfono (comentada - para recuperar en el futuro)
		// if (company.phone && company.phone.trim() && !/^[\+]?[0-9\s\-\(\)]+$/.test(company.phone.trim())) {
		// 	errors.phone = 'El formato del teléfono no es válido';
		// }

		// Validación opcional de la web (comentada - para recuperar en el futuro)
		// if (company.web && company.web.trim() && !/^https?:\/\/.+/.test(company.web.trim())) {
		// 	errors.web = 'La URL debe comenzar con http:// o https://';
		// }

		// Actualizar el estado con los errores
		this.setState({ errors });

		// Devolver si hay errores o no
		return Object.keys(errors).length === 0;
	};

	handleSubmit = async (e) => {
		e.preventDefault();

		// Primero validar el formulario
		if (!this.validateForm()) {
			// Si hay errores, marcar como submitted para mostrar los errores
			this.setState({ submitted: true });
			return;
		}

		this.setState({ isLoading: true });

		try {
			const { company } = this.state;

			// Preparar datos para enviar (solo campos con valor)
			const companyData = {
				name: company.name.trim(),
			};

			// Agregar campos opcionales solo si tienen valor
			if (company.vat_number && company.vat_number.trim()) {
				companyData.vat_number = company.vat_number.trim();
			}
			if (company.address && company.address.trim()) {
				companyData.address = company.address.trim();
			}
			if (company.postal_code && company.postal_code.trim()) {
				companyData.postal_code = company.postal_code.trim();
			}
			if (company.city && company.city.trim()) {
				companyData.city = company.city.trim();
			}
			if (company.province && company.province.trim()) {
				companyData.province = company.province.trim();
			}
			if (company.country_iso && company.country_iso.trim()) {
				companyData.country_iso = company.country_iso.trim();
			}
			if (company.email && company.email.trim()) {
				companyData.email = company.email.trim();
			}
			if (company.phone && company.phone.trim()) {
				companyData.phone = company.phone.trim();
			}
			if (company.web && company.web.trim()) {
				companyData.web = company.web.trim();
			}

			const response = await companyService.create(companyData);

			if (response.ok) {
				// Empresa creada exitosamente, ahora hacer refresh de tokens
				toastr.success(
					i18next.t("common.success"),
					i18next.t("createCompany.successMessage")
				);

				try {
					// Hacer refresh para obtener los tokens actualizados
					const refreshResponse = await authService.refresh();

					// if (refreshResponse.ok) {
					// 	toastr.success('¡Perfecto!', 'Empresa agregada al selector correctamente');
					// } else {
					// 	console.warn('Error al refrescar tokens:', refreshResponse.error);
					// 	toastr.warning('Aviso', 'Empresa creada, pero puede que necesites recargar la página para verla en el selector');
					// }
				} catch (refreshError) {
					console.error("Error al hacer refresh:", refreshError);
					toastr.warning(
						i18next.t("createCompany.warningTitle"),
						i18next.t("createCompany.warningReload")
					);
				}

				this.props.handleClose();
				// Dar tiempo a que los toasts se muestren antes de recargar
				setTimeout(() => {
					window.location.reload();
				}, 4000);
			} else {
				const formatted = errorFormating(response);
				const errorMessage =
					formatted?.general ||
					response?.errors?.[0]?.description ||
					i18next.t("createCompany.errorCreating");
				toastr.error("Error", errorMessage);
			}
		} catch (error) {
			console.error("Error creating company:", error);
			toastr.error(
				i18next.t("common.error"),
				i18next.t("createCompany.errorCreating")
			);
		} finally {
			this.setState({ isLoading: false });
		}
	};

	render() {
		const { company, errors, isLoading } = this.state;

		return (
			<div className="modal-body create-company-modal">
				<form onSubmit={this.handleSubmit}>
					<Row>
						<Col sm={8}>
							<FormGroup className="form-group" controlId="name">
								<FormLabel>
									{i18next.t("createCompany.labelName")}{" "}
									<span className="label-required">*</span>
								</FormLabel>
								<FormControl
									type="text"
									name="name"
									value={company.name}
									onChange={this.handleChange}
									onBlur={this.handleBlur}
									placeholder={i18next.t("createCompany.labelName")}
									isInvalid={this.checkValidField("name")}
								/>
								<FormControl.Feedback type="invalid">
									{errors.name}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={4}>
							<FormGroup className="form-group" controlId="vat_number">
								<FormLabel>{i18next.t("createCompany.labelVat")}</FormLabel>
								<FormControl
									type="text"
									name="vat_number"
									value={company.vat_number}
									onChange={this.handleChange}
									placeholder={i18next.t("createCompany.labelVat")}
									isInvalid={this.checkValidField("vat_number")}
								/>
								<FormControl.Feedback type="invalid">
									{errors.vat_number}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col sm={8}>
							<FormGroup className="form-group" controlId="address">
								<FormLabel>{i18next.t("createCompany.labelAddress")}</FormLabel>
								<FormControl
									type="text"
									name="address"
									value={company.address}
									onChange={this.handleChange}
									placeholder={i18next.t("createCompany.labelAddress")}
									isInvalid={this.checkValidField("address")}
								/>
								<FormControl.Feedback type="invalid">
									{errors.address}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={4}>
							<FormGroup className="form-group" controlId="postal_code">
								<FormLabel>
									{i18next.t("createCompany.labelPostalCode")}
								</FormLabel>
								<FormControl
									type="text"
									name="postal_code"
									value={company.postal_code}
									onChange={this.handleChange}
									placeholder={i18next.t("createCompany.labelPostalCode")}
									isInvalid={this.checkValidField("postal_code")}
								/>
								<FormControl.Feedback type="invalid">
									{errors.postal_code}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
					</Row>

					<Row>
						<Col sm={4}>
							<FormGroup className="form-group" controlId="city">
								<FormLabel>{i18next.t("createCompany.labelCity")}</FormLabel>
								<FormControl
									type="text"
									name="city"
									value={company.city}
									onChange={this.handleChange}
									placeholder={i18next.t("createCompany.labelCity")}
									isInvalid={this.checkValidField("city")}
								/>
								<FormControl.Feedback type="invalid">
									{errors.city}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={4}>
							<FormGroup className="form-group" controlId="province">
								<FormLabel>
									{i18next.t("createCompany.labelProvince")}
								</FormLabel>
								<FormControl
									type="text"
									name="province"
									value={company.province}
									onChange={this.handleChange}
									placeholder={i18next.t("createCompany.labelProvince")}
									isInvalid={this.checkValidField("province")}
								/>
								<FormControl.Feedback type="invalid">
									{errors.province}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={4}>
							<FormGroup className="form-group" controlId="country_iso">
								<FormLabel>{i18next.t("createCompany.labelCountry")}</FormLabel>
								<FormControl
									name="country_iso"
									value={company.country_iso}
									onChange={this.handleChange}
									isInvalid={this.checkValidField("country_iso")}
									as="select"
								>
									<option value="">
										{i18next.t("createCompany.selectCountry")}
									</option>
									{this.props.countries.map((country, index) => (
										<option key={index} value={country.iso}>
											{country.name}
										</option>
									))}
								</FormControl>
								<FormControl.Feedback type="invalid">
									{errors.country_iso}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
					</Row>

					<Row>
						<Col sm={4}>
							<FormGroup className="form-group" controlId="email">
								<FormLabel>Email</FormLabel>
								<FormControl
									type="email"
									name="email"
									value={company.email}
									onChange={this.handleChange}
									placeholder="Email"
									isInvalid={this.checkValidField("email")}
								/>
								<FormControl.Feedback type="invalid">
									{errors.email}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={4}>
							<FormGroup className="form-group" controlId="web">
								<FormLabel>Web</FormLabel>
								<FormControl
									type="url"
									name="web"
									value={company.web}
									onChange={this.handleChange}
									placeholder="Web"
									isInvalid={this.checkValidField("web")}
								/>
								<FormControl.Feedback type="invalid">
									{errors.web}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={4}>
							<FormGroup className="form-group" controlId="phone">
								<FormLabel>{i18next.t("createCompany.labelPhone")}</FormLabel>
								<FormControl
									type="text"
									name="phone"
									value={company.phone}
									onChange={this.handleChange}
									placeholder={i18next.t("createCompany.placeholderPhone")}
									isInvalid={this.checkValidField("phone")}
								/>
								<FormControl.Feedback type="invalid">
									{errors.phone}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
					</Row>

					<div className="modal-footer">
						<button
							type="button"
							onClick={this.props.handleClose}
							className="btn btn-outline-primary"
							disabled={isLoading}
						>
							{i18next.t("common.cancel")}
						</button>
						<SubmitButton
							type="submit"
							isLoading={isLoading}
							text={i18next.t("createCompany.btnCreate")}
							className="btn btn-primary"
						/>
					</div>
				</form>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	countries: state.companyReducer.countries || [],
});

export default connect(mapStateToProps, companyActions)(CreateCompanyModal);
